import api from '../../../services/api.service'; 
export const types = {
    SET_VALUE: 'auditoriaSetValue',
    SET_CNPJ: 'auditoriaSetCNPJ',
    SET_NAME: 'auditoriaSetName',
    SET_PERIOD: 'auditoriaSetPeriod',
    SET_SHOW_CARRIER: 'auditoriaetSethowCarrier',
    SET_SHOW_PERIOD: 'auditoriaetSethowPeriod',
    LOADER_SHOW: 'loaderShow',
    LOADER_HIDDEN: 'loaderHide'
}

export function setValue(value) {
    return {
        type: types.SET_VALUE,
        value
    }
}


export function setCNPJ(carrier) {
    return {
        type: types.SET_CNPJ,
        carrier,
    }
}

export function setName(name) {
    return {
        type: types.SET_NAME,
        name,
    }
}

export function setPeriod(period) {
    return {
        type: types.SET_PERIOD,
        period,
    }
}

export function setShowCarrier(showCarrier) {
    return {
        type: types.SET_SHOW_CARRIER,
        showCarrier,
    }
}

export function setShowPeriod(showPeriod) {
    return {
        type: types.SET_SHOW_PERIOD,
        showPeriod,
    }
}

export function loaderShow() {
    return {
        type: types.LOADER_SHOW,
        async: true,
    }
}

export function loaderHide() {
    return {
        type: types.LOADER_HIDDEN,
        async: false,
    }
} 
export function load() {
    return (dispatch, getState) => {
        const state = getState().crudAuditoriaIndicator.auditoria;
        const filter = {
            carrierDocument: state.filters.carrier.documentNumber || "",
            period: state.filters.period.period || "CURRENT_MONTH"
        }
        console.log("filter=", filter)
        const URL = `/api/v1/lognex/reports/indicators/divergence`;
        
        dispatch(loaderShow())
        api.post(URL, filter)
            .then(({ data }) => { 
                const {
                    quantity = 0,
                    divergentQuantity = 0, 
                } = data.data;
               
                dispatch(setValue({ countCteRecebidos:quantity, countCteDivergentes:divergentQuantity }))
                dispatch(loaderHide())
            })
            .catch((error) => {
                const { countCteRecebidos = 0, countCteDivergentes = 0 } = {};
                dispatch(setValue({ countCteRecebidos, countCteDivergentes }))
                console.log(error)
                dispatch(loaderHide())
            })
    }
}
